export default __webpack_public_path__ + "static/media/tensorflow.6d6f2e37.svg";